import { deleteCookie } from '../cookies';
import { initSessionData } from '../session_data';

function setCookie(key, value) {
  const d = new Date();
  d.setTime(d.getTime() + 90 * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + d.toUTCString(),
    domain = 'testowaplatforma123.net';
  document.cookie = `${key}=${value};${expires};path=/;domain=${domain}`;
}

document.addEventListener('click', (e) => {
  if (e.target.type == 'submit' && e.target.closest('.js-form-login')) {
    setCookie('session_brand', 'energycasino');
    deleteCookie('session_token');
  }
});

async function initEnvironmentCookie() {
  const key = "cp-task";
  const moduleBasicFunc = await import("../cookies");

  setTimeout(() => {
    const cookie = moduleBasicFunc.getCookie(key);
    let storage = localStorage.getItem(key) || false;
    if (cookie === storage) return;
    if (cookie && !storage) deleteCookie(key);
    moduleBasicFunc.setCookie(key, storage, 30);
    location.reload();
  }, 1000);

  setTimeout(() => {
    document
      .querySelector("#btn-dev-env-reload")
      .addEventListener("click", () => {
        const value =
          document.querySelector("#input-dev-env-domain").value || "dev";
        moduleBasicFunc.setCookie(key, value, 30);
      });
  }, 3000);
}

initSessionData();
initEnvironmentCookie();
